/** Отметки книги: статус чтения и избранное. */

import { useState } from 'react'
import { api, SHELF_LABELS } from '../api'
import type { ShelfStatus } from '../api'

const ORDER: ShelfStatus[] = ['reading', 'finished', 'want', 'dropped']

interface Props {
  bookId: number
  status: ShelfStatus
  favorite: boolean
  onChange: (status: ShelfStatus, favorite: boolean) => void
}

export function ShelfControls({ bookId, status, favorite, onChange }: Props) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const apply = async (next: { status?: ShelfStatus; favorite?: boolean }) => {
    setBusy(true)
    try {
      const saved = await api.setShelf(bookId, next)
      onChange(saved.status, saved.favorite)
      setError('')
    } catch {
      setError('не удалось сохранить')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="shelf">
      {ORDER.map((value) => (
        <button
          key={value}
          className={`btn${status === value ? ' btn--primary' : ''}`}
          disabled={busy}
          // Повторное нажатие снимает отметку — иначе её нельзя было бы убрать.
          onClick={() => void apply({ status: status === value ? 'none' : value })}
        >
          {SHELF_LABELS[value]}
        </button>
      ))}
      <button
        className={`btn${favorite ? ' btn--primary' : ''}`}
        disabled={busy}
        title="Избранное"
        onClick={() => void apply({ favorite: !favorite })}
      >
        {favorite ? '★' : '☆'}
      </button>
      {error && <span className="error">{error}</span>}
    </div>
  )
}
